export function convertHourToDecimal(hour: string): number {
  const [hoursStr, minutesStr] = hour.split(":");
  const hours = parseInt(hoursStr);
  const minutes = parseInt(minutesStr);
  const decimalValue = hours + minutes / 60;
  return decimalValue;
}
